import {
  NgClass,
  NgFor,
  NgIf,
  NgOptimizedImage,
  NgStyle,
} from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { Product, ProductImage } from 'src/app/classes/utility';
import { EnvironmentService } from 'src/app/service/environment.service';
import { ProductService } from '../../product.service';

@Component({
  selector: 'app-image-gallery',
  imports: [NgOptimizedImage, NgFor, NgClass, NgStyle, NgIf],
  templateUrl: './image-gallery.component.html',
  styleUrl: './image-gallery.component.scss',
})
export class ImageGalleryComponent implements OnChanges, OnInit {
  @Input() product!: Product;
  @ViewChildren('image') images!: QueryList<ElementRef>;

  _image!: ProductImage;
  _classes: any = [];
  _sleeve: any | undefined;
  window = this.environmentService.getWindow();
  constructor(
    private productService: ProductService,
    private environmentService: EnvironmentService
  ) {
    this.productService.sleeveObservable.subscribe((data) => {
      this._sleeve = data;
    });
  }

  ngOnInit(): void {
    if (this.product.product_type == 'Leather Sleeve') {
      this._classes =
        [2, 2, 2].map((x) => (x === 1 ? 'col-lg-6' : 'col-lg-12')) ?? [];
    } else {
      this._classes =
        [2, 1, 1].map((x) => (x === 1 ? 'col-lg-6' : 'col-lg-12')) ?? [];
    }
    this.productService.variantObservable.subscribe((data) => {
      this._image =
        this.product.images.find((x) => x.id == data.image_id) || this._image;
    });
  }

  scrollTo() {
    this.environmentService.getWindow()?.scrollTo();
  }

  scrollToImage(image: any, index: number) {
    this._image = image;
    const imageElement = this.images.toArray()[index].nativeElement;
    const rect = imageElement.getBoundingClientRect();
    const offsetTop = window.pageYOffset + rect.top + -100;
    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth',
    });
  }

  ngOnChanges() {
    this._image = this.product.images[0];
  }
}
